export enum CustomQuestionType {
  TEXT = "text",
  ANSWER_CHOICES = "answer_choices",
  YES_OR_NO = "yesno",
}
